<section>
  <!-- Web screen size navbar -->
  <div
    class="webNav-container web"
    [style.background-color]="env['colors']['primary']"
  >
    <div class="pamlab-logo-web">
      <a routerLink="/home">
        <img
          style="width: 300px"
          [(src)]="env['logo_paths']['webScreenNavBarPic']"
          class=""
          alt=""
        />
      </a>
      <p
        *ngIf="env['client'] !== 'uwf'"
        class="powered-by"
        style="color: white; padding: 0; margin: 0"
      >
        Powered by UWF PAM Lab
      </p>
    </div>

    <div class="nav-links">
      <a routerLink="/home" routerLinkActive="active">Home</a>
      <a routerLink="/aboutus" routerLinkActive="active">About</a>
      <a routerLink="/landing-page" routerLinkActive="active">Landing Page</a>
      <a routerLink="/feedback" routerLinkActive="active">Feedback</a>
      <a routerLink="/help-page" routerLinkActive="active">Help</a>
      <button mat-button [matMenuTriggerFor]="menu">
        <i class="fa-solid fa-circle-user"></i>
      </button>
      <mat-menu #menu="matMenu">
        <button mat-menu-item routerLink="/profile" routerLinkActive="active">
          Profile
        </button>
        <button
          mat-menu-item
          *ngIf="authService.hasPermission('users')"
          routerLink="/users"
          routerLinkActive="active"
        >
          Manage Users
        </button>
        <button mat-menu-item (click)="userLogout()" routerLinkActive="active">
          Logout
        </button>
      </mat-menu>
    </div>
  </div>
  <!-- end of web -->

  <!-- Smaller screen sizes navbar -->
  <div
    [style.background-color]="env['colors']['primary']"
    class="menu-trigger mobile"
  >
    <a routerLink="/home">
      <img
        [(src)]="env['logo_paths']['phoneScreenNavBarPic']"
        class=""
        alt=""
      />
    </a>
    <i (click)="isOpen = !isOpen" class="fas fa-bars"></i>
  </div>

  <div
    [style.background-color]="env['colors']['primary']"
    class="menu"
    *ngIf="isOpen"
    [@dropDownMenu]
  >
    <div class="menu-item">
      <a (click)="isOpen = !isOpen" routerLink="/home" routerLinkActive="active"
        >Home</a
      >
    </div>
    <div class="menu-item">
      <a
        (click)="isOpen = !isOpen"
        routerLink="/about"
        routerLinkActive="active"
        >About</a
      >
    </div>
    <div class="menu-item">
      <a
        (click)="isOpen = !isOpen"
        routerLink="/landing-page"
        routerLinkActive="active"
        >Landing Page</a
      >
    </div>
    <div class="menu-item">
      <a
        (click)="isOpen = !isOpen"
        routerLink="/feedback"
        routerLinkActive="active"
        >Feedback</a
      >
    </div>
    <div class="menu-item">
      <a
        (click)="isOpen = !isOpen"
        routerLink="/help-page"
        routerLinkActive="active"
        >Help</a
      >
    </div>
    <div class="menu-item">
      <a
        (click)="isOpen = !isOpen"
        routerLink="/profile"
        routerLinkActive="active"
        >Profile</a
      >
    </div>
    <div class="menu-item" *ngIf="authService.hasPermission('users')">
      <a
        (click)="isOpen = !isOpen"
        routerLink="/users"
        routerLinkActive="active"
        >Manage Users</a
      >
    </div>
    <div class="menu-item">
      <a (click)="userLogout()" routerLinkActive="active">Logout</a>
    </div>
  </div>
  <!-- end of mobile -->

  <div
    class="green-border"
    [style.background-color]="env['colors']['secondary']"
  ></div>
</section>
